/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Styles from './index.module.css';

export default function StrictContainer({ children, style, className }) {
  return (
    <div className={classNames(Styles.container, className)} style={style}>
      {children}
    </div>
  );
}

StrictContainer.propTypes = {
  children: PropTypes.node,
};

StrictContainer.defaultProps = {
  children: null,
};
